var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicPenCancelOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#E4E6EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11062_16242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16.5L20 20.5M24 24.5L20 20.5M20 20.5L24 16.5M20 20.5L16 24.5",
    stroke: "#E64E2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11062_16242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicPenCancelOptions);
export default __webpack_public_path__ + "static/media/magicPenCancelOptions.aecb3881823f22d278933c71f98971bd.svg";
export { ForwardRef as ReactComponent };